const isLocalhost = Boolean(
  typeof window !== 'undefined' && (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
  )
);

export const API_BASE_URL = isLocalhost
  ? 'http://localhost:4500'
  : 'https://api.tsil.net.in';

export default API_BASE_URL;
